import React from "react";
import { PublicLayout } from "../components/PublicLayout";

const Box = ({ title, children }) => (
    <section className="mb-8">
        <h2 className="font-heading text-2xl text-ink mb-3">{title}</h2>
        <div className="text-sm text-muted leading-relaxed space-y-3">{children}</div>
    </section>
);

export const PrivacyPolicy = () => (
    <PublicLayout>
        <div className="container-app py-12 max-w-3xl">
            <div className="text-xs uppercase tracking-[0.3em] text-soft">Informativa</div>
            <h1 className="font-heading text-5xl mt-2 mb-8">Privacy Policy</h1>
            <p className="text-xs text-soft mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

            <Box title="1. Titolare del trattamento">
                <p>Voci di Imprese — network.vocidiimprese.com. Per qualsiasi richiesta relativa al trattamento dei tuoi dati personali puoi contattarci all'indirizzo email indicato sul sito.</p>
            </Box>
            <Box title="2. Dati raccolti">
                <p>Raccogliamo: dati di registrazione (nome, email, password cifrata), dati di profilo (headline, settore, località, bio, competenze, esperienze, foto e video caricati), contenuti pubblicati (post, commenti, messaggi, richieste di aiuto), log tecnici (IP, user agent, timestamp) e preferenze cookie.</p>
            </Box>
            <Box title="3. Finalità e base giuridica (art. 6 GDPR)">
                <ul className="list-disc pl-5 space-y-2">
                    <li><strong>Esecuzione del contratto</strong>: fornitura del servizio di network e gestione account.</li>
                    <li><strong>Obblighi di legge</strong>: adempimenti normativi, antifrode.</li>
                    <li><strong>Consenso</strong>: marketing, cookie non necessari.</li>
                    <li><strong>Legittimo interesse</strong>: sicurezza della piattaforma, prevenzione abusi.</li>
                </ul>
            </Box>
            <Box title="4. Conservazione dei dati">
                <p>I dati sono conservati per tutta la durata dell'account. In caso di richiesta di cancellazione (diritto all'oblio) i dati sono rimossi entro 30 giorni, fatta salva la conservazione di dati richiesta da obblighi di legge.</p>
            </Box>
            <Box title="5. Diritti dell'interessato (artt. 15-22 GDPR)">
                <p>Hai diritto a: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione. Puoi esercitarli dalla pagina Impostazioni → "Elimina account" o scrivendoci. Hai diritto a presentare reclamo al Garante Privacy.</p>
            </Box>
            <Box title="6. Comunicazione a terzi">
                <p>I dati possono essere trattati da: fornitori tecnici (Spotify per embed, fornitori cloud per hosting). Non vendiamo i dati a terzi.</p>
            </Box>
            <Box title="7. Trasferimenti extra-UE">
                <p>Alcuni fornitori (es. provider cloud) possono trasferire dati in paesi terzi sulla base di Standard Contractual Clauses della Commissione Europea.</p>
            </Box>
            <Box title="8. Sicurezza">
                <p>Password cifrate con bcrypt, comunicazioni in HTTPS, accessi controllati. Non garantiamo l'assoluta sicurezza di internet, ma applichiamo le migliori pratiche del settore.</p>
            </Box>
            <p className="text-xs text-soft italic mt-8">Questo testo è fornito come modello base. Prima della pubblicazione in produzione, fallo revisionare da un professionista qualificato in materia di protezione dati.</p>
        </div>
    </PublicLayout>
);

export const CookiePolicy = () => (
    <PublicLayout>
        <div className="container-app py-12 max-w-3xl">
            <div className="text-xs uppercase tracking-[0.3em] text-soft">Informativa</div>
            <h1 className="font-heading text-5xl mt-2 mb-8">Cookie Policy</h1>
            <p className="text-xs text-soft mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

            <Box title="Cosa sono i cookie">
                <p>I cookie sono piccoli file di testo memorizzati dal tuo browser quando visiti un sito. Servono a far funzionare il sito, ricordare le preferenze e misurare l'efficacia dei contenuti.</p>
            </Box>
            <Box title="Categorie di cookie usate">
                <ul className="list-disc pl-5 space-y-2">
                    <li><strong>Necessari</strong>: indispensabili al funzionamento (es. token di sessione, consenso cookie). Sempre attivi.</li>
                    <li><strong>Analitici</strong>: ci aiutano a capire come viene usato il sito. Disattivati per impostazione predefinita.</li>
                    <li><strong>Marketing</strong>: per offrirti contenuti pertinenti. Disattivati per impostazione predefinita.</li>
                </ul>
            </Box>
            <Box title="Gestione del consenso">
                <p>Alla prima visita ti chiediamo il consenso con un banner. Puoi modificare le preferenze in qualsiasi momento cancellando i cookie dal browser oppure svuotando il consenso memorizzato e ricaricando la pagina.</p>
            </Box>
            <Box title="Cookie di terze parti">
                <p>Possono essere impostati cookie da: Spotify (embed audio), provider di hosting. Ognuno gestisce i propri cookie secondo la propria informativa.</p>
            </Box>
        </div>
    </PublicLayout>
);

export const Terms = () => (
    <PublicLayout>
        <div className="container-app py-12 max-w-3xl">
            <div className="text-xs uppercase tracking-[0.3em] text-soft">Contratto</div>
            <h1 className="font-heading text-5xl mt-2 mb-8">Termini e Condizioni d'uso</h1>
            <p className="text-xs text-soft mb-8">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

            <Box title="1. Oggetto">
                <p>Voci di Imprese Network è una piattaforma di social networking professionale, dedicata a imprenditori e liberi professionisti italiani, collegata al podcast Voci di Imprese.</p>
            </Box>
            <Box title="2. Iscrizione e account">
                <p>L'iscrizione richiede l'accettazione di questi Termini e della Privacy Policy. Devi avere almeno 18 anni. Devi fornire informazioni veritiere e mantenere riservate le credenziali. Sei responsabile delle attività svolte dal tuo account.</p>
            </Box>
            <Box title="3. Accesso al servizio">
                <p>L'accesso ai contenuti è gratuito e richiede la sola registrazione di un account. Puoi smettere di usare il servizio ed eliminare il tuo account in qualsiasi momento dalle Impostazioni.</p>
            </Box>
            <Box title="4. Contenuti caricati e licenza">
                <p>Rimani titolare dei diritti sui contenuti che carichi (foto, video, testo). Caricando contenuti, dichiari di possederne tutti i diritti necessari e di non violare diritti di terzi. Concedi a Voci di Imprese una licenza gratuita, non esclusiva, mondiale, per l'uso, la riproduzione e la distribuzione dei tuoi contenuti all'interno della piattaforma per finalità di servizio.</p>
            </Box>
            <Box title="5. Comportamento dell'utente">
                <p>Sono vietati: contenuti illeciti, diffamatori, discriminatori, lesivi della privacy altrui, spam, manipolazione del sistema, uso non autorizzato. Ci riserviamo il diritto di sospendere o eliminare account che violano queste regole.</p>
            </Box>
            <Box title="6. Limitazione di responsabilità">
                <p>Forniamo il servizio "as is". Non garantiamo l'esito di collaborazioni avviate tramite il network. Non rispondiamo di danni indiretti. Le interazioni tra utenti sono di esclusiva responsabilità degli stessi.</p>
            </Box>
            <Box title="7. Recesso">
                <p>Il servizio è gratuito: puoi cessarne l'uso ed eliminare il tuo account in qualsiasi momento dalle Impostazioni, senza alcun costo o preavviso.</p>
            </Box>
            <Box title="8. Modifiche">
                <p>Possiamo aggiornare questi Termini. Saremo trasparenti e ti notificheremo le modifiche sostanziali. L'uso continuato dopo la notifica costituisce accettazione.</p>
            </Box>
            <Box title="9. Legge applicabile e foro">
                <p>Si applica la legge italiana. Foro competente quello del consumatore, ove applicabile.</p>
            </Box>
            <p className="text-xs text-soft italic mt-8">Questo testo è fornito come modello base. Prima della pubblicazione in produzione, fallo revisionare da un legale qualificato.</p>
        </div>
    </PublicLayout>
);
